<template>
  <v-container class="content-box">
    <div class="main-title mt-10 pc-size"><slot>ユーザー一覧</slot></div>
    <div class="main-title mt-16 pt-5 mobile-size">
      <slot>ユーザー一覧</slot>
    </div>
    <v-tabs
      v-model="searchCondition.tab"
      class="search-tabs-video tabs-font pt-8"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.tabId"
        class="tab-name"
        :class="tab.tabId == 1 ? 'firsttab' : tab.tabId == 3 ? 'lasttab' : ''"
        @click="tabsChange(tab)"
      >
        {{ tab.title }}
      </v-tab>
    </v-tabs>
    <v-row class="mt-5">
      <v-spacer></v-spacer>
      <v-col class="justify-end searchpanel pc-size">
        <div class="">
          <field-label-normal>支部名</field-label-normal>
          <v-select
            :items="branches"
            item-text="name"
            item-value="code"
            v-model="searchCondition.branch_code"
            dense
            outlined
            hide-details="auto"
            placeholder="支部を選択"
            @change="changeBranch"
          >
          </v-select>
        </div>
        <div class="">
          <field-label-normal>組合員</field-label-normal>
          <v-select
            :items="companies"
            item-text="company_name"
            item-value="id"
            v-model="searchCondition.company_name"
            dense
            outlined
            hide-details="auto"
            placeholder="組合員を選択"
          >
          </v-select>
        </div>
        <div class="">
          <field-label-normal>キーワード</field-label-normal>
          <div class="d-flex">
            <v-text-field
              v-model="searchCondition.keyword"
              dense
              outlined
              placeholder="検索キーワードを入力"
              clearable
              hide-details="auto"
              v-on:keyup.enter="searchData"
            ></v-text-field>
            <v-btn
              color="primary"
              @click="searchData"
              class="btn-margin"
              height="40"
              width="100"
            >
              検索
            </v-btn>
            <v-btn
              @click="clearData"
              class="btn-margin mx-2 clearbtn"
              height="40"
              width="100"
              color="#46A319"
            >
              クリア
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="mobile-size">
      <v-row class="mt-0">
        <v-col col="12" sm="10">
          <field-label-normal>支部名</field-label-normal>
          <v-select
            :items="branches"
            item-text="name"
            item-value="code"
            v-model="searchCondition.branch_code"
            dense
            outlined
            hide-details="auto"
            placeholder="支部を選択"
            @change="changeBranch"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col col="12" sm="10">
          <field-label-normal>組合員</field-label-normal>
          <v-select
            :items="companies"
            item-text="company_name"
            item-value="id"
            v-model="searchCondition.company_name"
            dense
            outlined
            hide-details="auto"
            placeholder="組合員を選択"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col col="12" sm="10">
          <field-label-normal>キーワード</field-label-normal>
          <v-text-field
            v-model="searchCondition.keyword"
            dense
            outlined
            placeholder="検索キーワードを入力"
            clearable
            hide-details="auto"
            v-on:keyup.enter="searchData"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-btn
        color="primary"
        @click="searchData"
        class="btn-margin mt-4"
        height="40"
        width="100"
      >
        <!-- <svg-icon iconClass="Icon awesome-search" /> -->
        検索
      </v-btn>
      <v-btn
        @click="clearData"
        class="btn-margin mt-4 mx-4 white--text clearbtn"
        height="40"
        width="100"
        color="#46A319"
      >
        クリア
      </v-btn>
    </div>
    <v-row class="pt-4 pc-size">
      <v-col cols="2" sm="1" class="mr-6 v-input-control">
        <v-select
          :items="pages"
          v-model="searchCondition.size"
          dense
          solo
          hide-details
          append-icon="mdi-chevron-down"
          @update:items-per-page="searchData"
          class="select-page-size"
        >
          <template v-slot:selection="{ item }">
            <span class="d-flex justify-center" style="width: 100%">
              {{ item.text }}
            </span>
          </template>
        </v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        v-if="totalElements > 0"
        cols="6"
        sm="3"
        class="d-flex justify-end page-per-control"
      >
        {{ searchCondition.size * (searchCondition.page - 1) + 1 }}～{{
          searchCondition.size * searchCondition.page > totalElements
            ? totalElements
            : searchCondition.size * searchCondition.page
        }}件／全{{ totalElements }}件
      </v-col>
      <v-col v-else cols="6" sm="3" class="d-flex justify-end page-per-control">
        0件／全0件
      </v-col>
    </v-row>
    <div class="mobile-size">
      <v-row class="mt-4">
        <v-col class="v-input-control">
          <v-row class="m-size justify-end">
            <v-col cols="4" sm="12" class="text-right v-input-control">
              <v-select
                :items="pages"
                v-model="searchCondition.size"
                dense
                solo
                hide-details
                append-icon="mdi-chevron-down"
                class="select-page-size"
                @update:items-per-page="searchData"
              >
                <template v-slot:selection="{ item }">
                  <span class="d-flex justify-center" style="width: 100%">
                    {{ item.text }}
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="totalElements > 0"
          cols="12"
          sm="12"
          class="d-flex justify-end page-per-control"
        >
          {{ searchCondition.size * (searchCondition.page - 1) + 1 }}～{{
            searchCondition.size * searchCondition.page > totalElements
              ? totalElements
              : searchCondition.size * searchCondition.page
          }}件／全{{ totalElements }}件
        </v-col>
        <v-col
          v-else
          cols="12"
          sm="12"
          class="d-flex justify-end page-per-control"
        >
          0件／全0件
        </v-col>
      </v-row>
    </div>
    <div class="data-table-min-height">
      <v-data-table
        :headers="computedHeaders"
        :items="userinfo"
        v-model="selected"
        :page.sync="searchCondition.page"
        :items-per-page="searchCondition.size"
        @update:options="optionChange"
        @update:items-per-page="searchData"
        :server-items-length="totalElements"
        item-key="id"
        show-select
        hide-default-footer
        no-data-text="データがありません"
        class="list-table"
        @page-count="totalPages = $event"
        @click:row="rowClick"
        :sort-by.sync="sortByDefault"
        :sort-desc.sync="sortDescDefault"
        :header-props="{
          sortByText: '並び順'
        }"
      >
        <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
          <v-simple-checkbox
            :ripple="false"
            :value="isSelected"
            @input="select"
          ></v-simple-checkbox>
        </template>
      </v-data-table>
      <v-row class="del-size pt-1" justify="space-between">
        <v-btn
          height="40"
          width="125"
          color="del"
          class="del-content font-weight-bold white--text mr-2 mt-5 btn-right"
          :disabled="selected.length < 1"
          @click="deleteUser"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-col cols="12" sm="6" class="d-flex flex-row-reverse px-5">
          <v-pagination
            v-model="searchCondition.page"
            :length="totalPages"
            circle
            :total-visible="6"
            class="page-btn-admin"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <!-- <div class="punks">
      <v-row class="punks-area">
        <span class="punks-text">ユーザー一覧</span>
        <span class="punks-icon"
          ><svg-icon
            class="arrow-icon"
            iconClass="Icon ionic-ios-user-arrow-forward"
        /></span>
      </v-row>
    </div> -->
    <!-- 削除確認ポップアップ -->
    <confirm-dialog
      icon="mdi-alert"
      iconColor="#E8A43E"
      text="削除してよろしいですか"
      confirmText="はい"
      cancelText="キャンセル"
      :show="confirmDialogShow"
      @yes="confirmDelete"
      @cancel="confirmDialogShow = false"
    ></confirm-dialog>
  </v-container>
</template>
<script>
import FieldLabelNormal from "@/components/FormElements/FieldLabelNormal";
import { searchUsers, deleteUsers } from "@/api/user";
import { PAGES } from "@/utils/pages";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import { USERTABID, USERTAB } from "@/utils/mst-user";
import { getBranch, getCompany } from "@/api/common";

export default {
  name: 'Users',
  components: {
    ConfirmDialog,
    FieldLabelNormal
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  data: () => ({
    prevRoute: null,
    isFirstPage: true,
    title: "組合員",
    tabs: [
      { tabId: 1, title: "組合員" },
      { tabId: 2, title: "営業員" },
      { tabId: 3, title: "管理者" }
    ],
    pages: PAGES,
    totalElements: 0,
    totalPages: 0,
    allCount: 0,
    sortByDefault: "id",
    sortDescDefault: true,
    confirmDialogShow: false,
    headers: [],
    user_tab: USERTAB,
    usertabid: USERTABID,
    defaultHeaders: [
      { text: '担当者', value: 'staff_name', width: "180px", align: "left" },
      { text: '担当者メール', value: 'email', width: "200px", align: "left" },
      { text: '所属部署', value: 'staff_department', width: "175px", align: "left" },
      { text: '電話番号', value: 'tel', width: "150px", align: "center" },
    ],
    searchCondition: {
      isIni: true,
      size: 5,
      page: 1,
      tab: 0,
      tabId: 1,
    },
    isSearching: false,
    deleteBtn: false,
    login_user: '',
    userinfo: [],
    selected: [],
    branches: [],
    companies: [],
  }),
  computed: {
    computedHeaders() {
      return this.headers;
    }
  },
  created: async function () {
    await this.refresh();
  },
  methods: {
    refresh() {
      this.setHeader();
      getBranch().then((response) => {
        this.branches = response.data;
      });

      getCompany().then((response) => {
        this.companies = response.data;
      });
    },
    setHeader() {
      let tempheaders = [];
      this.headers = [];

      let addcolumn1 = [
        { text: '支部名', value: 'branch_name', width: "150px", align: 'left' },
        { text: '会社名', value: 'company_name', width: "200px", align: "left" },
      ];
      let addcolumnnot2 = [
        { text: '支部名', value: 'branch_name', width: "150px", align: 'left' },
      ];

      if (this.searchCondition.tabId == this.usertabid.ADMIN) {
        tempheaders = addcolumnnot2.concat(this.defaultHeaders);
      } else if (this.searchCondition.tabId == this.usertabid.SALE_MEMBER) {
        tempheaders = addcolumn1.concat(this.defaultHeaders);
      } else {
        tempheaders = this.defaultHeaders;
      }

      this.headers = tempheaders;
    },
    tabsChange(data) {
      this.searchCondition.tabId = data.tabId;
      this.searchCondition.tab = data.tabId - 1;
      this.selected = [];
      this.searchData();
      this.setHeader();
      return this.title = data.title;
    },
    rowClick(data) {
      localStorage.setItem("userSearchCondition", JSON.stringify(this.searchCondition));
      this.$router.push("/admin/users/edit/" + data.id); // 管理者のログイン画面に遷移
    },
    searchData() {
      if (this.isFirstPage) {
        this.searchCondition.page = 1;
      }
      this.search();
    },
    optionChange(option) {
      // ソート変更があった時に
      this.searchCondition.sort = option.sortBy[0];
      this.searchCondition.sortDesc = option.sortDesc[0];
      this.searchCondition.page = option.page;
      this.search();
    },
    waitforCurrentSearchAndSearch() {
      if (this.isSearching) {
        setTimeout(() => this.waitforCurrentSearchAndSearch(), 100);
      } else {
        this.search();
      }
    },
    async search() {
      this.$store.commit("SET_LOADING", true);
      // 検索リクエスト
      this.isSearching = true;
      this.login_user = JSON.parse(localStorage.getItem("adminUserInfo"));
      if (!this.login_user) {
        this.$router.push({
          name: "AdminLogin",// 管理者ログイン画面に遷移
        });
        return;
      }
      const search = {
        size: this.searchCondition.size,
        tabId: this.searchCondition.tabId,
        tab: this.searchCondition.tab,
        keyword: this.searchCondition.keyword,
        branchCode: this.searchCondition.branch_code,
        companyName: this.searchCondition.company_name,
        login_id: this.login_user.id
      };
      // 並び順
      if (this.searchCondition.sort != null) {
        search["sort"] = this.searchCondition.sort;
      }

      if (this.searchCondition.sortDesc != null) {
        search["sortDesc"] = this.searchCondition.sortDesc;
      }

      search["page"] = this.searchCondition.page,
        await searchUsers(search).then(response => {
          const dataList = [];
          response.data.data.forEach((data) => {
            dataList.push({
              "id": data.id,
              "branch_name": data.name ? data.name : '',
              "company_name": data.company_name,
              "staff_name": data.staff_name,
              "email": data.email,
              "staff_department": data.staff_department,
              "tel": data.tel,
            })
          });
          this.userinfo = dataList;
          this.totalElements = response.data.total;
          this.totalPages = response.data.last_page;
          this.allCount = response.all_count;
        }).catch(() => {
          this.$router.push("/admin/login");
        });
      this.isSearching = false;
      this.isFirstPage = true;
      this.selected = [];
      this.$store.commit("SET_LOADING", false);
    },
    deleteUser() {
      if (this.searchCondition.tabId == this.user_tab.ADMIN) {
        const ids = [];
        for (const user of this.selected) {
          ids.push(user.id);
        }
        if (ids.length == this.allCount) {
          this.$store.commit("SAVE_DIALOG", {
            text: "管理者は少なくとも１ユーザー必要な為、この処理は行えません。",
            icon: "mdi-alert",
          });
        } else {
          this.confirmDialogShow = true;
        }
      } else {
        this.confirmDialogShow = true;
      }
    },
    async confirmDelete() {
      this.confirmDialogShow = false;
      this.$store.commit("SET_LOADING", true);
      this.login_user = JSON.parse(localStorage.getItem("adminUserInfo"));
      const ids = [];
      for (const user of this.selected) {
        ids.push(user.id);
      }
      let params = {
        ids: ids,
        user_id: this.login_user.id,
        tab: this.searchCondition.tabId
      };

      // 一括削除リクエスト
      await deleteUsers(params).then((response) => {
        this.confirmDialogShow = false;
        if (response.success) {
          this.$store.commit("SAVE_DIALOG", {
            text: "削除しました",
            icon: "mdi-checkbox-marked-circle-outline",
          });
          if (response.message == 'logout') {
            this.$store.commit("SET_USERINFO", {});
            localStorage.setItem("adminUserInfo", null);
            this.$router.push({
              name: "AdminLogin",// 管理者ログイン画面に遷移
            });
          }
        } else {
          if (response.message == 'lastUserDeleteError') {
            this.$store.commit("SAVE_DIALOG", {
              text: "管理者は少なくとも１ユーザー必要な為、この処理は行えません。",
              icon: "mdi-alert",
            });
          } else {
            this.$router.push("/admin/login");
          }
        }
      });
      // もう一回検索で表示を更新する
      await this.search();
    },
    changeBranch() {
      let params = {
        branch_code: this.searchCondition.branch_code,
        searchflg: true,
      }
      getCompany(params).then((response) => {
        this.companies = response.data;
      });
    },
    clearData() {
      this.searchCondition.branch_code = '';
      this.searchCondition.company_name = '';
      this.searchCondition.keyword = '';
      getBranch().then((response) => {
        this.branches = response.data;
      });

      getCompany().then((response) => {
        this.companies = response.data;
      });
      this.searchData();
    }
  },
  async mounted() {
    this.login_user = JSON.parse(localStorage.getItem("adminUserInfo"));
    if (this.login_user) {
      if (this.login_user.user_code != this.user_tab.ADMIN) {
        this.$router.push({
          name: "401",// 利用者ログイン画面に遷移
        });
      } else {
        if (this.prevRoute.name === "EditUser") {
          const savedSearchCondition = JSON.parse(localStorage.getItem("userSearchCondition"));
          if (savedSearchCondition) {
            this.isFirstPage = false;
            this.searchCondition = savedSearchCondition;
            this.waitforCurrentSearchAndSearch();
          }
          this.setHeader();
        }
        localStorage.removeItem("userSearchCondition");
      }
    } else {
      this.$router.push({
        name: "AdminLogin",// 管理者ログイン画面に遷移
      });
    }
    const navigationBar = this.$parent.$parent.$parent;
    navigationBar.setFooter(['ユーザー一覧'], '', true)
  },
}
</script>
<style lang="scss" scoped>
.userinfo {
  .pageCount {
    font-size: $size-tip;
    color: $color-text;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab {
    border-left: 2px solid transparent;
    border-right: 2px solid beige;
    width: 148px !important;
  }
  .v-window {
    overflow: visible;
  }
  .chip-text {
    color: $white !important;
    width: 125px !important;
    justify-content: center;
  }
  .item-label {
    color: $dark-blue;
    font-size: $size-label;
  }
}
.row {
  margin-bottom: 0 !important;
}
.del {
  background-color: #f03748 !important;
}
.del-size {
  margin-left: 2px;
}
.del-content {
  font-size: 16px !important;
  :hover {
    background-color: RGBA(240, 55, 72, 0.5);
  }
}
.main-title {
  font-size: $size-title;
  color: $admin-color-title;
  font-weight: bold;
}
.tab-name {
  font-size: $size-label;
}
// .punks-area {
//   width: 100%;
//   align-items: center;
//   background: white;
//   margin-bottom: -10px !important;
// }
// .punks-text {
//   color: $admin-color-title;
//   font-size: 13px;
// }
.arrow-icon {
  height: 11px;
}
.searchicon {
  .svg-icon {
    width: 20.72px;
    height: 20.72px;
  }
}
.searchpanel {
  display: flex;
  .fieldset {
    margin: 5px 6px -1px 0px !important;
  }
  .v-input {
    margin: 1px 8px 0px 0;
    min-width: 200px;
  }
  .v-btn {
    height: 40px;
    color: $white;
    width: 70px;
    background-color: $admin-color-title !important;
  }

  .clearbtn {
    background-color: $green !important;
  }
}
/**申請一覧のパンくずの */
@media screen and (max-width: 1000px) {
  .data-table-min-height {
    min-height: 50vh;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1400px) {
  .data-table-min-height {
    min-height: 50vh;
  }
}
@media screen and (max-width: $size-mobile) {
  // .punks-area {
  //   margin-bottom: -40px !important;
  // }
  // .punks {
  //   left: 20px;
  // }
}
</style>
<style lang="scss">
.userinfo {
  .pc-size,
  .mobile-size {
    .v-input {
      .v-label {
        font-size: $size-normal !important;
        color: $color-text !important;
      }
    }
  }
  .search-tabs-video .v-slide-group__content .v-tab.v-tab--active {
    font-weight: 900 !important;
  }
  @media screen and (max-width: $size-mobile) {
    .v-data-table__mobile-row__header {
      color: $dark-blue !important;
    }
  }
  .v-badge__wrapper {
    left: 104px !important;
    top: -5px !important;
  }
}
.admin-user-list-dialog {
  margin: 10px !important;
  .round-card {
    .v-card__text {
      padding: 0 13px !important;
    }
  }
  .theme--light.v-label {
    font-size: $size-normal !important;
    color: $color-text !important;
  }
  .v-input--selection-controls {
    margin-top: 0 !important;
  }
}
.v-data-table-header th {
  border-bottom: 1px solid $admin-secondary !important;
}
.v-data-table-header-mobile__select {
  display: none !important;
}
.v-data-table__checkbox .v-input--selection-controls__input {
  display: none !important;
}
.v-data-table {    
    overflow-x: scroll;
}
tbody {
  tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: RGBA(255, 230, 125, 0.5) !important;
  }
}
// .punks {
//   position: absolute;
//   bottom: 60px;
//   left: 40px;
//   right : 0px;
//   padding: 0 0 12px;
//   .punks-icon {
//     .arrow-icon {
//       vertical-align: top;
//       margin-top: 8px;
//     }
//   }
// }
</style>